/* import __COLOCATED_TEMPLATE__ from './cardless-conversion-modal-pricing5.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    model: {
      onOpenChange: (open: boolean) => void;
      activePlanId?: number;
      oneDollarTrialExtension?: boolean;
      selfServe?: boolean;
      canUseEarlyStageDetection?: boolean;
      canUseProductSpecialistCTAs?: boolean;
    };
  };
}

export default class CardlessConversionModalPricing5 extends Component<Signature> {
  constructor(owner: unknown, args: any) {
    super(owner, args);
  }

  get activePlanId() {
    return this.args.model?.activePlanId;
  }

  get selfServe() {
    return this.args.model?.selfServe;
  }

  get oneDollarTrialExtension() {
    return this.args.model?.oneDollarTrialExtension;
  }

  get contextualLinkVariant() {
    if (this.args.model?.canUseEarlyStageDetection) {
      return 'early_stage';
    } else if (this.args.model?.canUseProductSpecialistCTAs) {
      return 'ask_product_specialist';
    } else {
      return 'talk_to_sales';
    }
  }

  @action
  onOpenChange(open: boolean) {
    this.args.model?.onOpenChange(open);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Modal::CardlessConversionModalPricing5': typeof CardlessConversionModalPricing5;
    'react/modal/cardless-conversion-modal-pricing5': typeof CardlessConversionModalPricing5;
  }
}
